import { render, staticRenderFns } from "./EditWithAiButton.vue?vue&type=template&id=2714f6e8&"
import script from "./EditWithAiButton.vue?vue&type=script&lang=ts&"
export * from "./EditWithAiButton.vue?vue&type=script&lang=ts&"
import style0 from "./EditWithAiButton.vue?vue&type=style&index=0&id=2714f6e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports